import { useUser } from '@stackframe/react';
import { Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import { AppShell } from './components/AppShell.tsx';
import { Dashboard } from './pages/Dashboard.tsx';
import { Doors } from './pages/Doors.tsx';
import { Events } from './pages/Events.tsx';
import { Cardholders } from './pages/Cardholders.tsx';
import { Controllers } from './pages/Controllers.tsx';
import { ControlPanel } from './pages/ControlPanel.tsx';
import { Zones } from './pages/Zones.tsx';
import { Hotel } from './pages/Hotel.tsx';
import { Schedules } from './pages/Schedules.tsx';
import { Holidays } from './pages/Holidays.tsx';
import { AccessLevels } from './pages/AccessLevels.tsx';
import { SettingsPage } from './pages/SettingsPage.tsx';
import { Developer } from './pages/Developer.tsx';
import { Welcome } from './pages/Welcome.tsx';
import { getActiveStackTeamId } from './lib/activeTenant.ts';

interface Props {
  activeStackTeamId: string | null;
  setActiveStackTeamId: (id: string | null) => void;
}

export function App({ activeStackTeamId, setActiveStackTeamId }: Props) {
  const user = useUser();
  if (!user) return <Welcome />;
  return (
    <AppShell activeStackTeamId={activeStackTeamId} onChangeTenant={setActiveStackTeamId}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/doors" element={<Doors />} />
        <Route path="/events" element={<Events />} />
        <Route path="/cardholders" element={<Cardholders />} />
        <Route path="/access-levels" element={<AccessLevels />} />
        <Route path="/schedules" element={<Schedules />} />
        <Route path="/holidays" element={<Holidays />} />
        <Route path="/zones" element={<Zones />} />
        <Route path="/controllers" element={<Controllers />} />
        <Route path="/controllers/:id" element={<ControlPanel />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/developer" element={<Developer />} />
      </Routes>
    </AppShell>
  );
}

// Keep helper for the initial render path.
export function initialActiveTeam(): string | null {
  return getActiveStackTeamId();
}
